import React, { Component } from 'react';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { usersService } from '../../_services/users.service';

class SpecialtiesOption extends Component
{
  state = {
    defaultValue: null,
    selected: null,
    options: []
  }

  componentDidMount() {
    usersService.getOptionsSpecialty()
      .then(results => {
        this.setState({
          options: results.map(result => {
            return { value: result.id, label: result.name }
          })
        }, this.selectDefaultAndBubble)
      })
  }

  selectDefaultAndBubble() {
    const option = this.state.options.find(option => {
      return option.label === this.props.defaultValue
    });

    this.setState({ selected: option })

    this.props.handleSelected(option)
  }

  render () {
    const { options, selected } = this.state;

    if (options.length === 0) {
      return <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    }

    return <Select
      value={selected || ''}
      placeholder='Select a specialty'
      isClearable={true}
      options={options}
      onChange={option => {
        this.setState({
          selected: option ?? null
        })

        this.props.handleSelected(option ?? null)
      }}
      isDisabled={this.props.disabled}
      styles={{
        container: (styles) => {
          return {
            ...styles,
            zIndex: 15,
          }
        },
        placeholder: (styles) => {
          return {
            ...styles, 
            color: 'RGB(201, 201, 201)',
            fontWeight: 300,
          };
        },
        control: (styles) => {
          return {
            ...styles, 
            border: this.props.invalid ? '1px solid red' : '',
          };
        },
      }}
    />
  }
}

export default SpecialtiesOption